import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
export var useFilters = function useFilters(entries) {
  var _useState = useState(_objectSpread({}, entries.reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, []));
  }, {}))),
      filtersState = _useState[0],
      setFiltersState = _useState[1];

  var createHandler = function createHandler(key, setState) {
    return function (selected) {
      return setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, selected));
      });
    };
  };

  var selectHandlers = entries.reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, createHandler(key, setFiltersState)));
  }, {});
  return {
    filtersState: filtersState,
    selectHandlers: selectHandlers
  };
};